import { useEffect } from 'react';
import { usePusher } from '../../contexts/PusherContext';
import { useCompany } from '../../contexts/CompanyContext';

/**
 * Bridge component that listens for 'credits-updated' Pusher events
 * on the company channel and updates CompanyContext state accordingly.
 * Must be rendered inside both PusherProvider and CompanyProvider.
 */
const CreditsPusherListener: React.FC = () => {
  const pusherChannel = usePusher();
  const { setAiTimeMinutes, setResetsAt } = useCompany();

  useEffect(() => {
    if (!pusherChannel) return;

    const handleCreditsUpdated = (data: {
      ai_time_minutes: number;
      resets_at: string | null;
    }) => {
      console.log('Received credits-updated event:', data);
      setAiTimeMinutes(data.ai_time_minutes);
      setResetsAt(data.resets_at);
    };

    pusherChannel.bind('credits-updated', handleCreditsUpdated);

    return () => {
      pusherChannel.unbind('credits-updated', handleCreditsUpdated);
    };
  }, [pusherChannel, setAiTimeMinutes, setResetsAt]);

  return null;
};

export default CreditsPusherListener;
